import {Component, inject, signal, WritableSignal} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ITenant, UserService} from 'frontier';
import {AppService} from "../../../api/generated";

@Component({
  selector: 'app-trapo2',
  standalone: true,
  imports: [],
  templateUrl: './trapo2.component.html',
  styleUrl: './trapo2.component.scss',
})
export class Trapo2Component {
  href: string;
  private _userService: UserService = inject(UserService);
  private _appService: AppService = inject(AppService);
  private _sanitizer: DomSanitizer = inject(DomSanitizer);

  sanitizedUrl: WritableSignal<SafeResourceUrl> = signal<SafeResourceUrl>(null);
  error: WritableSignal<string> = signal<string>(null);
  currentTenant: WritableSignal<string> = signal<string>(null);

  constructor() {
    this._userService.userGetGetTenantInfos().subscribe((r: object): void => {
      const res = r as {
        default: string,
        current: string,
        tenants: ITenant[],
      };
      this.currentTenant.set(res.current);

      this._appService.servicesGettrapo().subscribe((url: string): void => {
        this.href = url;
        this.sanitizedUrl.set(this._sanitizer.bypassSecurityTrustResourceUrl(this.href));
      });
    });
  }
}
